const SummaryCard = ({ label, value }) => (
  <div className="rounded-lg border border-gray-200 bg-bg-surface p-4">
    <div className="text-sm text-text-secondary">{label}</div>
    <div className="mt-2 text-2xl font-semibold text-text-primary">{value}</div>
  </div>
);

export default SummaryCard;
